import { Box, ContainerProps, useTheme } from '../../chakra'

/**
 * A Box that centers your content with a maxWidth of 1500px
 *
 * See: https://storybook.beta.vndly.com/?path=/docs/components-container--docs
 */
export const Container = (props: ContainerProps) => {
  const theme = useTheme()
  return <Box px={{ base: 6, lg: 12 }} {...props} mx="auto" w="full" maxW={theme.breakpoints.xl} />
}
